/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiDiscountType;
(function (ApiDiscountType) {
    ApiDiscountType["DISCOUNT_TYPE_DEFAULT"] = "DiscountTypeDefault";
    ApiDiscountType["DISCOUNT_TYPE_CODE"] = "DiscountTypeCode";
})(ApiDiscountType || (ApiDiscountType = {}));
export function ApiDiscountTypeFromJSON(json) {
    return ApiDiscountTypeFromJSONTyped(json, false);
}
export function ApiDiscountTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiDiscountTypeToJSON(value) {
    return value;
}
